import axios from "axios";

const baseURL = process.env.REACT_APP_BASE_URL;

const api = axios.create({
  baseURL: baseURL,
});

export const sendToAquarius = async (id: number) => {
  const token = localStorage.getItem("token");

  const result = await api.post(
    "send_to_aqweb/",
    { id },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      timeout: 600000,
    }
  );

  return result.data;
};
